import React from 'react'
import { title, description } from '../constants/activity-seo'
import SEO from '../shared/seo'

import ZonaVirtualContent from '../components/organisms/ZonaVirtualContent/zonaVirtualContent'

function ZonaVirtual() {
  const [isIos, setIsIos] = React.useState(false)

  React.useEffect(() => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      setIsIos(true)
    }else{
      setIsIos(false)
    }
  }, [])

  return (
    <>
      <SEO title={title + 'ZonaVirtual'} description={description} />
      <ZonaVirtualContent isIos={isIos}/>
    </>
  )
}

export default ZonaVirtual
